module.exports = "/assets/data/efcd6a1178680a15d46b4279faaa14e7-MK46.data.json";